// extracted by mini-css-extract-plugin
export default {"container":"Q9-z","creativeContainer":"R9-z","copy":"S9-z","cta":"T9-z","disabled":"U9-z","flipped":"V9-z","productCard":"W9-z"};